import { employeesApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { EmployeeDocumentsGateway } from './EmployeeDocumentsGateway';
import type { EmployeeDocumentResponse, UploadDocumentInput } from './types';

export class HttpEmployeeDocumentsGateway implements EmployeeDocumentsGateway {
  private readonly request = createJsonClient(employeesApiBaseUrl);

  list(employeeId: string, signal?: AbortSignal): Promise<EmployeeDocumentResponse[]> {
    return this.request(`/api/employees/${employeeId}/documents`, undefined, signal);
  }

  upload(employeeId: string, input: UploadDocumentInput): Promise<EmployeeDocumentResponse> {
    const form = new FormData();
    form.append('file', input.file);
    form.append('documentType', String(input.documentType));
    form.append('documentName', input.documentName);
    if (input.customTypeDescription) form.append('customTypeDescription', input.customTypeDescription);
    if (input.expiryDate) form.append('expiryDate', input.expiryDate);
    // The shared client drops its JSON Content-Type for a FormData body, refreshes an expired session once, and turns a problem response into an ApiError.
    return this.request(`/api/employees/${employeeId}/documents`, { method: 'POST', body: form });
  }

  async archive(employeeId: string, documentId: string, reason: string | null): Promise<void> {
    await this.request(`/api/employees/${employeeId}/documents/${documentId}/archive`, { method: 'POST', body: JSON.stringify({ reason }) });
  }

  requestCorrection(employeeId: string, documentId: string, reason: string): Promise<EmployeeDocumentResponse> {
    return this.request(`/api/employees/${employeeId}/documents/${documentId}/correction-requests`, { method: 'POST', body: JSON.stringify({ reason }) });
  }

  downloadUrl(employeeId: string, documentId: string): string {
    return `${employeesApiBaseUrl}/api/employees/${employeeId}/documents/${documentId}/download`;
  }
}
